<div
  class="organizer-shared-layout-dashboard"
  [class.organizer-shared-layout-dashboard--headerless]="!hasHeader"
>
  <app-organizer-shared-layout-dashboard-header
    class="organizer-shared-layout-dashboard__header"
  ></app-organizer-shared-layout-dashboard-header>

  <main class="organizer-shared-layout-dashboard__content container">
    <div
      class="organizer-shared-layout-dashboard__content__container"
      [class.container]="!fullWidth"
    >
      <ng-content></ng-content>
    </div>
  </main>

  <app-organizer-shared-footer
    *ngIf="hasFooter"
    class="organizer-shared-layout-dashboard__footer"
    [ngClass]="footerClass"
  ></app-organizer-shared-footer>
</div>
